import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-style-six',
  templateUrl: './pricing-style-six.component.html',
  styleUrls: ['./pricing-style-six.component.scss']
})
export class PricingStyleSixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
